/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ACSStrictHttpResponse } from '../../acs-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LobbyModel } from '../../models/lobby-model';

export interface LobbySavePost$Params {
      body?: LobbyModel
}

export function lobbySavePost(http: HttpClient, rootUrl: string, params?: LobbySavePost$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, lobbySavePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as ACSStrictHttpResponse<string>;
    })
  );
}

lobbySavePost.PATH = '/Lobby/Save';
